<template>
	<div id="season">
    <ol class="breadcrumb pull-right">
      <li><router-link :to="{path: '/'}">Home</router-link></li>
      <li>Duel</li>
      <li class="active">List Season</li>
    </ol>
    <!-- end breadcrumb -->
    <!-- begin page-header -->
    <h1 class="page-header">List Season</h1>
    <!-- end page-header -->
    <div class="row">
      <div class="col-md-12">
        <!-- begin panel -->
        <div class="panel panel-inverse">
          <div class="panel-heading">
						<div class="pull-right">
              <button type="button" class="btn btn-success btn-xs m-r-5" @click="createSeason()"><span class="fa fa-plus"></span> Tambah Season</button>
            </div>
            <h4 class="panel-title">List Season</h4>
          </div>
          <div class="panel-body">
            <app-datatable 
              :items="seasonList" 
              :headers="headers"
							v-on:dblClicked="updateSeason()"
							v-on:deleted="deleteSeason($event)"
              v-on:selected="selectedRow = $event" 
            />
          </div>
        </div>
      </div>
    </div>
    <app-spinner v-if="isLoading"></app-spinner>
  </div>
</template>

<script>
import Moment from 'moment'
import DuelService from '@/services/duel.js'
import DataTable from '@/components/plugins/DataTable'
import Spinner from '@/components/plugins/Spinner'

export default {
	name: 'season',
	components: {
		'app-datatable': DataTable,
		'app-spinner': Spinner,
	},
	data: function () {
		return {
			isLoading: false,
			seasonList: [],
			selectedRow: null,
			search: null,
			pagination: {
				perPage: 25,
				currentPage: 1,
				totalPages: 0,
				sortMode: 'desc',
			},
			headers: ['Name', 'Started At', 'Ended At', 'Status'],
		}
	},
	mounted: function () {
		this.fetchData();
	},
	methods: {
		fetchData: function () {
			let context = this
			this.isLoading = true

			DuelService.getSeason(function (response) {
				context.seasonList = []
				context.isLoading = false

				if (response.success) {
					response.data.forEach(item => {
						var row = {
							id: item.id,
							data: [
								item.name || '-',
								Moment(item.started_at).format('YYYY-MM-DD') || '-',
								Moment(item.ended_at).format('YYYY-MM-DD') || '-',
								item.status || '-',
							],
						}

						context.seasonList.push(row)
					})
				} else {
					alert('Terjadi Kesalahan : ' + response.message)
				}
			})
		},
		createSeason: function () {
			this.$router.push({ path: '/season/form' })
		},
		updateSeason: function () {
			var seasonId = this.selectedRow.id
			this.$router.push({ path: '/season/form/', query: { id: seasonId } })
		},
		deleteSeason: function (season) {
			var seasonId = season.id
			var context = this
			var confirmed = window.confirm("Apakah anda yakin akan menghapus group ini?")
			if (confirmed) {
				if (season.data[3] !== 'not active') {
					alert('Season masih aktif')
				} else {
					this.isLoading = true
					DuelService.deleteSeason(seasonId, function (result) {
						if (result.success) {
							alert('Data Terhapus')
							context.fetchData()
							context.isLoading = false
						} else {
							alert('Terjadi Kesalahan : ' + response.message)
						}
					})
				}
			}
		},
	}
}
</script>


// WEBPACK FOOTER //
// Season.vue?2a37dc5c